import { useMutation, useQueryClient } from "@tanstack/react-query";
import collectionApiClient from "../../../api/collection";

const useSetSponsoredCollectionMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      collectionId,
      sponsored,
    }: {
      collectionId: string;
      sponsored: boolean;
    }) =>
      sponsored
        ? collectionApiClient.sponsorCollection(collectionId)
        : collectionApiClient.unsponsorCollection(collectionId),
    onSettled: (_data, _error, variables) =>
      Promise.all([
        queryClient.refetchQueries({ queryKey: ["collections"] }),
        queryClient.refetchQueries({
          queryKey: ["collection", variables.collectionId],
        }),
        queryClient.refetchQueries({
          queryKey: ["sponsoredCollectionCode", variables.collectionId],
        }),
      ]),
  });
};

export default useSetSponsoredCollectionMutation;
